import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// --- Auto Storage Migration ---
(function() {
  try {
    const idMap = {
      'MHS363': 'MHS363',
      'MHS358': 'MHS358',
      'MHS364': 'MHS364',
      'MHS386': 'MHS386',
      'MHS363': 'mhs363',
      'MHS358': 'mhs358',
      'MHS364': 'mhs364',
      'MHS386': 'mhs386'
    };

    const cleanStorage = (storage) => {
      if (!storage) return;
      for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (!key) continue;
        let val = storage.getItem(key);
        if (val && /MHS100[1-4]/i.test(val)) {
          Object.keys(idMap).forEach(k => {
            val = val.split(k).join(idMap[k]);
          });
          try {
            let parsed = JSON.parse(val);
            if (Array.isArray(parsed)) {
              parsed = parsed.map(emp => {
                if (emp && typeof emp === 'object') {
                  if (emp.emp_id && idMap[emp.emp_id]) emp.emp_id = idMap[emp.emp_id];
                  if (emp.id && idMap[emp.id]) emp.id = idMap[emp.id];
                  if (emp.username && idMap[emp.username]) emp.username = idMap[emp.username];
                  const reqs = [emp.first_name, emp.last_name, emp.email, emp.phone, emp.nssf_no, emp.tin_no, emp.department, emp.designation, emp.gross_salary, emp.bank_name, emp.account_no];
                  if (reqs.some(f => !f || String(f).trim() === '')) {
                    emp.record_status = 'Incomplete';
                    emp.status = 'Incomplete';
                  }
                }
                return emp;
              });
              val = JSON.stringify(parsed);
            }
          } catch(e) {}
          storage.setItem(key, val);
        }
      }
    };

    cleanStorage(window.localStorage);
    cleanStorage(window.sessionStorage);
  } catch (e) {
    console.error('Storage auto-migration error:', e);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

